import { ref } from 'vue'

const showModal = ref(false)
const openExternally = ref(false)
const urlValue = ref([])
const speedBumpValue = ref(null)

export function useModal() {
  const openModal = ({ externally = false, url = [], speedBump = null }) => {
    openExternally.value = externally
    urlValue.value = url
    speedBumpValue.value = speedBump

    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
  }

  return {
    showModal,
    openExternally,
    urlValue,
    speedBumpValue,
    openModal,
    closeModal,
  }
}
